import { useState, useEffect } from 'react';
import { noop } from '@mindtickle/utils';
interface DropdownData {
  trackVisibility?: () => void;
}

const useDropdownData = ({ trackVisibility = noop }: DropdownData = {}) => {
  const [isVisible, setVisible] = useState(false);
  const [hideDropdownContent, setHideDropdownContent] = useState(false);
  const onHideDropdownContent = () => {
    setHideDropdownContent(!hideDropdownContent);
  };

  const handleVisibilityChange = (state: boolean) => {
    setHideDropdownContent(false);
    setVisible(!isVisible);
    trackVisibility?.();
  };

  useEffect(() => {
    if (hideDropdownContent) {
      setVisible(false);
    }
  }, [hideDropdownContent]);

  return {
    isVisible,
    handleVisibilityChange,
    onHideDropdownContent,
    hideDropdownContent,
  };
};

export default useDropdownData;
